import { Navigate, Outlet } from 'react-router-dom';

import { useSession } from '@/features/auth/useSession';

/**
 * Keeps a signed-in visitor off the sign-in and registration screens. Renders
 * nothing while the session resolves, so the auth form does not flash up for
 * someone who is already signed in.
 */
export function RedirectIfSignedIn() {
  const { isSignedIn, isLoading } = useSession();

  if (isLoading) return null;
  if (isSignedIn) return <Navigate to="/" replace />;

  return <Outlet />;
}
